const LEGACY_TELEHEALTH_ORG_IDS = new Set([
    // Shared client mode
    'c8bc936b-5870-4b39-b7df-aae236688528', // Author
    'efd73618-21b6-441e-9916-15d34ffca765', // Author QA
    '99567487-0e00-49cf-a574-644d4db827b0', // South Park
]);

export const isNewVideoCallingEnabled = (orgId?: string): boolean => {
    if (!orgId) {
        return true;
    }

    return !LEGACY_TELEHEALTH_ORG_IDS.has(orgId);
};
